import axios from "axios";
import { OC_TOKEN } from "utils/constants";

const axiosInstance = () => {
  const token = localStorage.getItem(OC_TOKEN);
  var url = process.env.REACT_APP_BASE_URL_DEV;
  if (process.env.REACT_APP_MODE === "prod") {
    url = process.env.REACT_APP_BASE_URL_PROD;
  } else if (process.env.REACT_APP_MODE === "dev") {
    url = process.env.REACT_APP_BASE_URL_DEV;
  } else {
    url = process.env.REACT_APP_BASE_URL_LOCAL;
  }

  const enviroment = url;
  return axios.create({
    baseURL: enviroment,
    headers: {
      authorization: token ? `Bearer ${token}` : null,
    },
  });
};

export default axiosInstance;
